module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controllers"
  }, [(!_vm.appState.loggedIn) ? _c('div', [(_vm.appState.loading) ? _c('h1', [_vm._v("Loading....")]) : _vm._e(), _vm._v(" "), (!_vm.appState.loading) ? _c('button', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        _vm.backend.loginToGoogle()
      }
    }
  }, [_vm._v("Login")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.appState.loggedIn) ? _c('div', [(!_vm.vmsObj) ? _c('h3', [_vm._v("Select style or click an object to start editing")]) : _vm._e(), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStyle),
      expression: "selectedStyle"
    }],
    staticClass: "style-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedStyle = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.filteredStyles), function(style, key) {
    return _c('option', {
      key: key,
      domProps: {
        "selected": style.name === _vm.selectedStyle,
        "value": style.name
      }
    }, [_vm._v(_vm._s(style.name))])
  })), _vm._v("\n      Filter Styles\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styleFilterQuery),
      expression: "styleFilterQuery"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.styleFilterQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.styleFilterQuery = $event.target.value
      }
    }
  }), _vm._v("\n      Use click action\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appState.useClick),
      expression: "appState.useClick"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.appState.useClick) ? _vm._i(_vm.appState.useClick, null) > -1 : (_vm.appState.useClick)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appState.useClick,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appState.useClick = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appState.useClick = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appState.useClick = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.vmsObj) ? _c('div', {
    staticClass: "rangers"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.x),
      expression: "vmsObj.position.x"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.x)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.position.x = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.x),
      expression: "vmsObj.position.x"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.x)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.x = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.x_formula),
      expression: "vmsObj.position.x_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.position.x_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.x_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        X Pos\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.y),
      expression: "vmsObj.position.y"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.y)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.position.y = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.y),
      expression: "vmsObj.position.y"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.y)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.y = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.y_formula),
      expression: "vmsObj.position.y_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.position.y_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.y_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Y Pos\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.z),
      expression: "vmsObj.position.z"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.z)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.position.z = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.z),
      expression: "vmsObj.position.z"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.z)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.z = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.z_formula),
      expression: "vmsObj.position.z_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.position.z_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.z_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Z Pos\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.x),
      expression: "vmsObj.translate.x"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.x)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.translate.x = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.x),
      expression: "vmsObj.translate.x"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.x)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.translate.x = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.x_formula),
      expression: "vmsObj.translate.x_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.x_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.translate.x_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        X Translate\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.y),
      expression: "vmsObj.translate.y"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.y)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.translate.y = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.y),
      expression: "vmsObj.translate.y"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.y)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.translate.y = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.y_formula),
      expression: "vmsObj.translate.y_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.y_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.translate.y_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Y Translate\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.grunge.gOpacity),
      expression: "vmsObj.grunge.gOpacity"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "0.1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.grunge.gOpacity)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.grunge.gOpacity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.grunge.gOpacity),
      expression: "vmsObj.grunge.gOpacity"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "0.1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.grunge.gOpacity)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.grunge.gOpacity = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.grunge.gOpacity_formula),
      expression: "vmsObj.grunge.gOpacity_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.grunge.gOpacity_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.grunge.gOpacity_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Grunge Opacity\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.grunge.gColor_formula),
      expression: "vmsObj.grunge.gColor_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.grunge.gColor_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.grunge.gColor_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Grunge Hex Color e.g.) 0xbababa\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.vmsObj && _vm.vmsObj.scale) ? _c('div', {
    staticClass: "rangers"
  }, [_c('div', [_vm._v("\n        Scale X:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.scale.x_formula),
      expression: "vmsObj.scale.x_formula"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.scale.x_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.scale.x_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Scale Y:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.scale.y_formula),
      expression: "vmsObj.scale.y_formula"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.scale.y_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.scale.y_formula = $event.target.value
      }, _vm.refresher]
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n        Size X:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.size.x_formula),
      expression: "vmsObj.size.x_formula"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.size.x_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.size.x_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Size Y:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.size.y_formula),
      expression: "vmsObj.size.y_formula"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.size.y_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.size.y_formula = $event.target.value
      }, _vm.refresher]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d15663f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CMS/Controllers/Controllers.vue
// module id = 600
// module chunks = 0